import { SystemProps, CSSObject } from "@chakra-ui/react";

type TVariableStyles = {
  width?: SystemProps["width"];
  height?: SystemProps["height"];
  minWidth?: SystemProps["minWidth"];
  isSelected?: boolean;
  isDisabled?: boolean;
  isFullWidth?: boolean;
};

const getStyleOverrides = ({ width, height, minWidth, isFullWidth }: TVariableStyles): CSSObject => ({
  ...(width && { width }),
  ...(height && { height }),
  ...(minWidth && { minWidth }),
  ...(isFullWidth && { minWidth: "initial" }),
});

export default getStyleOverrides;
